import SyncHelper from '../Helper/SyncHelper';
import APIController from './APIController';
import {useWebSocket} from "../Context/WebSocketContext";
const Category = () =>{
    //Requesthelper
    const {basicRequest, jsonRequest, getWorkspaceId} = APIController()
    const {readOffline} = SyncHelper()
    const {isOnline} = useWebSocket()

    const fetchCategories = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return []; 
        if (isOnline === false) return readOffline('categories');

        const data = await jsonRequest(`/${workspaceId}/categories`);
        return data;
    };

    const fetchInactivCategories = async () => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return [];
        const data = await jsonRequest(`/${workspaceId}/categories/inactive`);
        return data;
    };

    const getCategory = async (id) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/categories/${id}`);
        return data;
    };

    const addCategory = async (categoryDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/categories/new`, "POST", categoryDTO);
        return data;
    };

    const editCategory = async (id, categoryDTO) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/categories/edit/${id}`, "PUT", categoryDTO);
        return data;
    };

    const reactivateCategory = async (id) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/categories/reactivate/${id}`, "PUT");
        return data;
    };

    const deleteCategory = async (id) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/categories/${id}`, "DELETE");
        return data;
    };

    const permaDeleteCategory = async (id) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/categories/perma/${id}`, "DELETE");
        return data;
    };

    /* Return the api calls and the categories  */
    return {
        fetchCategories,
        fetchInactivCategories,
        editCategory,
        reactivateCategory,
        getCategory,
        addCategory,
        deleteCategory,
        permaDeleteCategory
    };
}

export default Category